export type ProductVariantDataSearchParams = {
    productVariant: string | null;
    airflow: string | null;
    airflowUnit: string | null;
    supplyAirflow: string | null;
    extractAirflow: string | null;
    pressureDropSupply: string | null;
    pressureDropExtract: string | null;
    pressureDropOutdoor: string | null;
    pressureDropExhaust: string | null;
    climateCountry: string | null;
    climateCity: string | null;
    size: string | null;
    coil: string | null;
    dampers: string[] | null;
};

export type ProductVariantDataSearchParamsForShare = {
    [K in keyof Omit<
        ProductVariantDataSearchParams,
        'airflow' | 'dampers'
    >]: NonNullable<
        Omit<ProductVariantDataSearchParams, 'airflow' | 'dampers'>[K]
    >;
} & {
    market: string;
};
export const getLiteQueryParams = (searchParams: URLSearchParams) => {
    const lowerCaseParams = new URLSearchParams(
        [...searchParams].map(([key, value]) => [key.toLowerCase(), value])
    );
    return {
        airflow: lowerCaseParams.get('airflow'),
        airflowUnit: lowerCaseParams.get('airflowunit'),
        climateCity: lowerCaseParams.get('climatecity'),
        climateCountry: lowerCaseParams.get('climatecountry'),
        /** Airflow in airflowUnit if set, otherwise market default */
        extractAirflow: lowerCaseParams.get('extractairflow'),
        pressureDropExhaust: lowerCaseParams.get('pressuredropexhaust'),
        pressureDropExtract: lowerCaseParams.get('pressuredropextract'),
        pressureDropOutdoor: lowerCaseParams.get('pressuredropoutdoor'),
        pressureDropSupply: lowerCaseParams.get('pressuredropsupply'),
        productVariant:
            lowerCaseParams.get('productvariant') ||
            lowerCaseParams.get('productname'),
        /** Airflow in airflowUnit if set, otherwise market default */
        supplyAirflow: lowerCaseParams.get('supplyairflow'),
        size: lowerCaseParams.get('size'),
        coil: lowerCaseParams.get('coil'),
        dampers: lowerCaseParams.getAll('dampers')
    };
};
